import script from "./PaymentMethodDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodDetails.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethodDetails.vue?vue&type=style&index=0&id=376a9cbf&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-376a9cbf"]])

export default __exports__